/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkSendPushNotificationResponse
 */
export interface BulkSendPushNotificationResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkSendPushNotificationResponse
     */
    noDeviceCount: number;
    /**
     * 
     * @type {number}
     * @memberof BulkSendPushNotificationResponse
     */
    notFoundCount: number;
    /**
     * 
     * @type {number}
     * @memberof BulkSendPushNotificationResponse
     */
    queuedCount: number;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof BulkSendPushNotificationResponse
     */
    jobId: string;
}

/**
 * Check if a given object implements the BulkSendPushNotificationResponse interface.
 */
export function instanceOfBulkSendPushNotificationResponse(value: object): value is BulkSendPushNotificationResponse {
    if (!('noDeviceCount' in value) || value['noDeviceCount'] === undefined) return false;
    if (!('notFoundCount' in value) || value['notFoundCount'] === undefined) return false;
    if (!('queuedCount' in value) || value['queuedCount'] === undefined) return false;
    if (!('jobId' in value) || value['jobId'] === undefined) return false;
    return true;
}

export function BulkSendPushNotificationResponseFromJSON(json: any): BulkSendPushNotificationResponse {
    return BulkSendPushNotificationResponseFromJSONTyped(json, false);
}

export function BulkSendPushNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkSendPushNotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'noDeviceCount': json['noDeviceCount'],
        'notFoundCount': json['notFoundCount'],
        'queuedCount': json['queuedCount'],
        'jobId': json['jobId'],
    };
}

export function BulkSendPushNotificationResponseToJSON(value?: BulkSendPushNotificationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'noDeviceCount': value['noDeviceCount'],
        'notFoundCount': value['notFoundCount'],
        'queuedCount': value['queuedCount'],
        'jobId': value['jobId'],
    };
}

